import { render, staticRenderFns } from "./SortCalendarAscending.vue?vue&type=template&id=266b87cd"
import script from "./SortCalendarAscending.vue?vue&type=script&lang=js"
export * from "./SortCalendarAscending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports